import React, { Component, createContext } from 'react';

const DrawerContext = createContext();
export default DrawerContext;

const { Provider, Consumer: DrawerConsumer } = DrawerContext;

class DrawerProvider extends Component {
  state = {
    drawer: false,
  };

  actions = {
    onDrawer: () => {
      this.setState({
        drawer: !this.state.drawer,
      });
    },
  };

  render() {
    const context = {
      state: this.state,
      actions: this.actions,
    };

    return <Provider value={context}>{this.props.children}</Provider>;
  }
}

export { DrawerConsumer, DrawerProvider };
